const originalConsoleError = console.error;
console.error = function (...args) {
  if (typeof args[0] === 'string' && args[0].includes('AG Grid: error #200')) {
    return;
  }
  originalConsoleError.apply(console, args);
};

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { provideHttpClient } from '@angular/common/http';
import { ModuleRegistry, ClientSideRowModelModule } from 'ag-grid-community';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
